import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import DateRangePicker from "rsuite/DateRangePicker";
import {
  startOfDay,
  endOfDay,
  addDays,
  subDays,
} from "date-fns";
import moment from "moment";
import { toast } from "react-toastify";

import AlertError from "../common/alertError";
import AlertSuccess from "../common/alertSuccess";

import { connect } from "react-redux";
import { AuditReport } from "../../store/appointment";

const AuditReportGenerate = ({show, onHide, AuditReport}) => {
  const [dateRange, setDateRange] = useState([
    startOfDay(new Date()),
    endOfDay(new Date()),
  ]);

  const callback = (res) => {
    if (!res) {
      toast(<AlertError message="Failed to generate report" />);
      return;
    }

    if (res.status === 204) {
      toast(<AlertError message="No data found" />);
      return;
    }

    if (res.status === 200) {
      const blob = new Blob([res.data], {
        type: "text/csv",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "audit_report.csv");

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      toast(<AlertSuccess message="Audit report downloaded" />);
    }
  };

  const handleDownload = () => {
    if (!dateRange || dateRange.length !== 2) {
      toast(<AlertError message="Please select date range" />);
      return;
    }

    const payload = {
      appointment_start_date: moment(dateRange[0]).format(
        "YYYY-MM-DD"
      ),
      appointment_end_date: moment(dateRange[1]).format(
        "YYYY-MM-DD"
      ),
    };

    // console.log(payload);

    AuditReport(payload, callback);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="md"
    >
      <Modal.Header closeButton>
        <Modal.Title>Generate Audit Report</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="p-3 border rounded">
          <h6 className="mb-3">Select Date Range</h6>

          <DateRangePicker
            cleanable={false}
            placement="auto"
            value={dateRange}
            onChange={(value) => setDateRange(value)}
            style={{ width: "100%" }}
            ranges={[
              {
                label: "Today",
                value: [
                  startOfDay(new Date()),
                  endOfDay(new Date()),
                ],
              },
              {
                label: "Yesterday",
                value: [
                  startOfDay(addDays(new Date(), -1)),
                  endOfDay(addDays(new Date(), -1)),
                ],
              },
              {
                label: "Last 7 Days",
                value: [
                  startOfDay(subDays(new Date(), 6)),
                  endOfDay(new Date()),
                ],
              },
              {
                label: "Last 30 Days",
                value: [
                  startOfDay(subDays(new Date(), 29)),
                  endOfDay(new Date()),
                ],
              },
              {
                label: "Last 90 Days",
                value: [
                  startOfDay(subDays(new Date(), 89)),
                  endOfDay(new Date()),
                ],
              },
              {
                label: "Last One Year",
                value: [
                  startOfDay(subDays(new Date(), 364)),
                  endOfDay(new Date()),
                ],
              },
            ]}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>

        <Button variant="primary" onClick={handleDownload}>
          Download CSV
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => ({
  AuditReport: (data, callback) =>
    dispatch(AuditReport(data, callback)),
});

export default connect(
  null,
  mapDispatchToProps
)(AuditReportGenerate);